import DayJS from 'dayjs';

const getUsersSessionsViews = async (viewId, fromDate = null) => {
  let startDate = fromDate ? fromDate : DayJS().subtract(7, 'day');
  let endDate = DayJS().subtract(1, 'day');
  let months = endDate.diff(startDate, "month"); 
  let days = endDate.diff(startDate, "day"); 

  return new Promise((resolve, reject) => {

    let dimensions = 'ga:hour';
    if (months > 12)
      dimensions = 'ga:year';
    else if (months > 1)
      dimensions = 'ga:yearMonth';
    else if (days > 1)
      dimensions = 'ga:date';

    let request = gapi.client.analytics.data.ga.get({ 
      'ids':  'ga:' + viewId,
      'start-date': dimensions === 'ga:hour' ? 'today' : startDate.format('YYYY-MM-DD'),
      'end-date': dimensions === 'ga:hour' ? 'today' : endDate.format('YYYY-MM-DD'),
      'metrics': 'ga:users,ga:sessions,ga:pageviews',
      'dimensions': dimensions
    });
    request.execute(results => {
      const labels = [];
      const users = [];
      const sessions = [];
      const pageviews = [];
      if (results.error) {
        reject(results.error);
        return;
      }
      for (let row of results.rows) {
        let label = row[0];
        if (label.length === 8)
          label = DayJS(label).format('MMM DD'); 
        else if (label.length === 6)
          label = DayJS(label + '01').format('MMM YYYY'); 
        else if (label.length === 4)
          label = label; 
        labels.push(label);
        users.push(row[1]);
        sessions.push(row[2]);
        pageviews.push(row[3]);
      }
      resolve({ labels, datasets: [
        { 
          label: 'Users',
          borderColor: 'rgba(100, 169, 241, 1)',
          backgroundColor: 'rgba(100, 169, 241, 0.2)',
          fill: false,
          data: users 
        }, {
          label: 'Sessions', 
          borderColor: 'rgba(241, 188, 100, 1)',
          backgroundColor: 'rgba(241, 188, 100, 0.2)',
          fill: false,
          data: sessions
        }, {
          label: 'Views', 
          borderColor: 'rgba(37, 180, 125, 1)',
          backgroundColor: 'rgba(37, 180, 125, 0.2)',
          fill: false,
          data: pageviews
        }] 
      });
    });
  });
};

// Get activity for the last 30 minutes
const getActivityPerMinutes = async (viewId) => {
  return new Promise((resolve, reject) => {
    let request = gapi.client.analytics.data.realtime.get({ 
      'ids':  'ga:' + viewId,
      'metrics': 'rt:pageviews',
      'dimensions': 'rt:minutesAgo' // ga:medium,rt:referralPath,rt:trafficType,
    });
    const formatThis = (minutesAgo) => {
      return DayJS().subtract(minutesAgo, 'minute').format('HH:mm');
    }
    request.execute(results => {
      let minutesAgo = [];
      let pageviews = [];
      if (results.error) {
        reject(results.error);
        return;
      }
      for (let index = 0; index < 30; index++) {
        let row = results.rows?.find(x => parseInt(x[0]) === index);
        minutesAgo.push(row ? formatThis(parseInt(row[0])) : formatThis(index));
        pageviews.push(row ? parseInt(row[1]) : 0);
      }
      minutesAgo = minutesAgo.reverse();
      pageviews = pageviews.reverse();
      const activityPerMinutes = { labels: minutesAgo, datasets: [{ 
          label: 'Views',
          borderWidth: { top: 5, left: 0, right: 0, bottom: 0 },
          borderColor: 'rgba(100, 169, 241, 1)',
          backgroundColor: 'rgba(100, 169, 241, 0.75)',
          fill: true,
          data: pageviews 
        }] 
      };
      resolve(activityPerMinutes);
    });
  });
};

// Get current activity (active users and pages)
const getRealtimeActivity = async (viewId) => {
  return new Promise((resolve, reject) => {
    let request = gapi.client.analytics.data.realtime.get({ 
      'ids':  'ga:' + viewId,
      'metrics': 'rt:activeUsers',
      'dimensions': 'rt:pagePath', // ,ga:medium,rt:referralPath,rt:trafficType,rt:source
    });
    request.execute(results => {
      const pages = results.rows?.map(x => ({ page: x[0], users: parseInt([1]) }));
      resolve({ users: parseInt(results.totalsForAllResults ? results.totalsForAllResults['rt:activeUsers'] : 0), pages });
    });
  });
};

export { getUsersSessionsViews, getActivityPerMinutes, getRealtimeActivity };